/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MonthlyStudentTable.vue?vue&type=template&id=229b0c10&scoped=true&"
import script from "./MonthlyStudentTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./MonthlyStudentTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MonthlyStudentTable.vue?vue&type=style&index=0&id=229b0c10&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b0c10",
  null
  
)

export default component.exports